import { $ } from "@olmokit/dom";
import AuthFormRegister from "@olmokit/core/auth/form-register";
import "@olmokit/core/forms/input/filled";
import "@olmokit/core/forms/select/filled";
import "@olmokit/core/forms/checkbox";
import "./Register.scss";

/**
 * Component: AuthRegister
 */
export function AuthRegister($root?: HTMLElement) {
  $root = $root ? $(".AuthRegister:", $root) : $root;
  const $auth = $(".AuthRegister:");
  const $error = $(".error", $auth);

  AuthFormRegister($root, {
    succeded: (formData, instance, response) => {
      $error.innerHTML = response.data.msg || "";
      location.href = response.data.redirect;

    },
    failed: (formData, instance, response) => {
      const { data } = response;
      $error.innerHTML = data.msg;
    },
  });
}
